import React from 'react'
import { SlideShowD } from '../components/PeopleStrength/SlideShowD/SlideShowD'
const StrengthPeople = () => {
  return (
    <>
    <div className='mt-20'/>
<SlideShowD/>
    </>
  )
}

export default StrengthPeople